<div class="py-4">
    <div class="mx-auto max-w-7xl">
        <div class="mx-auto mt-8 flow-root max-w-2xl sm:mt-10 lg:mx-0 lg:max-w-none">
            <div class="-mt-8 sm:-mx-4 sm:columns-2 sm:text-[0] lg:columns-3">
                @for(item of componentModel.reviews.value; track $index){
                    <div class="pt-8 sm:inline-block sm:w-full sm:px-4">
                        <figure class="rounded-2xl p-8 text-sm leading-6 bg-card">
                            <blockquote class="text-light text-light">
                                <p>“{{item.review.value}}”</p>
                            </blockquote>
                            <figcaption class="mt-6 flex items-center gap-x-4">
                                <div>
                                    <div class="font-semibold text-normal">{{item.nickname.value}}</div>
                                </div>
                            </figcaption>
                        </figure>
                    </div>
                }
            </div>
        </div>
    </div>
</div>
